


//-- UOM sets should be identical
const Volume_UOM_Units: string[] = ['Units','EA']
const Spend_UOM_Units: string[] = ['Units','EA']

const Volume_UOM_Case: string[] = ['Cases','CS','PAL']
const Spend_UOM_Case: string[] = ['Cases','CS','PAL']

const Volume_UOM_BUOM: string[] = ['BU', 'BUOM']  // BU & BUOM = Base Unit of Measure, usually cases, but can be EA.. designated on each SAP material
const Spend_UOM_BUOM: string[] = ['BU', 'BUOM']

const Volume_UOM_Weight: string[] = ['Weight','LB']
const Spend_UOM_Weight: string[] = ['Weight','LB']

const Volume_UOM_Ordered: string[] = ['PAL', 'ORD']
const Spend_UOM_Ordered: string[] = ['PAL', 'ORD']

const Volume_UOM_ListSales: string[] = ['ListSales','PCT']
const Spend_UOM_ListSales: string[] = ['ListSales','PCT']

const Volume_UOM_StatCase: string[] = ['StatCs']
const Spend_UOM_StatCase: string[] = ['StatCs']


const Spend_Basis_Fixed: string[] = ['Fixed']
const Spend_Basis_Consumed: string[] = ['Consumed','Consumption']
const Spend_Basis_Shipped: string[] = ['Shipped','Shipment']
const Spend_Basis_Shipped_Direct: string[] = ['ShippedDirect', 'DirectShipped']
const Spend_Basis_Shipped_Indirect: string[] = ['ShippedIndirect', 'IndirectShipped']
const Spend_Basis_Shipped_Net: string[] = ['ShippedNet', 'NetShipped']

const Spend_Ship_Volume_Basis_All: string = "All"
const Spend_Ship_Volume_Basis_OSOnly: string = "OSOnly"
const Spend_Ship_Volume_Basis_BOMCompOnly: string = "BOMCompOnly"
const Spend_Ship_Volume_Basis_BOMHeader: string = "BOMHeader"

const PaymentMethod_OffInvoice = 'OffInvoice'
const PaymentMethod_Check = 'Check'
const PaymentMethod_Deduction = 'Deduction'
const PaymentMethod_Rebate = 'Rebate'

const EventSpend_Type_EDLP = 'EDLP';
const EventSpend_Type_Coupon: string = 'CustomerCouponRedemption_Variable';

const Status_Type_Approved = 'Approved';
const Status_Type_Cancelled = 'Cancelled';
const Status_Type_RevisionsDenied = 'RevisionsDenied';
const Status_Type_Initial = 'Initial';
const Status_Type_Revised = 'Revised';
const Status_Type_PendingApproval = 'PendingApproval';
const Status_Type_Rejected = 'Rejected';


const Plan_Calc_UOM_Default = 'EA';
const Plan_Type_Simple = 'SimplePlanning';
const Plan_ShipperHandlingMethod_Decomposition = 'Decomposition';


const Spend_Calc_Method_TPM_Actual = "TPM Actual"
const Spend_Calc_Method_TPM_LE = "TPM LE"
const Spend_Calc_Method_Consumption = "Consumption"
const Spend_Calc_Method_Shipments = "Shipment"
const Spend_Calc_Method_Override = "Override"
const Spend_Calc_Method_Planned = "TPM Plan"


const Spend_Redistrib_Basis_Fixed = 'Fixed'
const Spend_Redistrib_Basis_Full = 'Full'
const Spend_Redistrib_Basis_Pcnt = 'Pcnt'
const Spend_Redistrib_Basis_ConsOvrlp = 'ConsOvrlp'
const Spend_Redistrib_Basis_ShipOvrlp = 'ShipOvrlp'

const Actual_Volume_Method_Normal = 'Normal'
const Actual_Volume_Method_Anchor = 'Anchor'

const Auto_Anchor_Policy_Auto = 'Auto'
const Auto_Anchor_Policy_Manual = 'Manual'
const Auto_Anchor_Policy_None = 'None'

const Calc_VolumeLayer_Type_EDLP = ['EDLP'];
const Calc_VolumeLayer_Type_Merch = ['Merchandising'];
const Event_Type_MerchSimple = ['Merchandising_Simple'];
const Event_Types_Other: string[] = ['Other', 'ShopperMarketing', 'Special'];
const Event_Type_Display: string[] = ['Shipper'];

const Product_RowType_Consumer = 'Consumer'
const Product_RowType_Finished = 'Finished'
const Product_RowType_Display = 'Display'


export {
  Volume_UOM_Units, Volume_UOM_Case, Volume_UOM_Weight, Volume_UOM_ListSales,Volume_UOM_StatCase,Volume_UOM_BUOM, Volume_UOM_Ordered,
  Spend_UOM_BUOM, Spend_UOM_Ordered,  Spend_UOM_Units, Spend_UOM_Case, Spend_UOM_Weight, Spend_UOM_ListSales,Spend_UOM_StatCase,
  Plan_Calc_UOM_Default, Plan_Type_Simple, Plan_ShipperHandlingMethod_Decomposition,
  Spend_Basis_Fixed, Spend_Basis_Consumed, Spend_Basis_Shipped,
  Spend_Basis_Shipped_Direct,Spend_Basis_Shipped_Indirect,Spend_Basis_Shipped_Net,EventSpend_Type_Coupon,
  Status_Type_Approved,Status_Type_Cancelled, Status_Type_Rejected, Status_Type_RevisionsDenied, Status_Type_Initial, Status_Type_Revised, Status_Type_PendingApproval,
  Spend_Calc_Method_TPM_Actual, Spend_Calc_Method_TPM_LE, Spend_Calc_Method_Consumption, Spend_Calc_Method_Shipments, Spend_Calc_Method_Override, Spend_Calc_Method_Planned,
  Spend_Redistrib_Basis_Fixed, Spend_Redistrib_Basis_Full, Spend_Redistrib_Basis_Pcnt, Spend_Redistrib_Basis_ConsOvrlp, Spend_Redistrib_Basis_ShipOvrlp,
  Actual_Volume_Method_Normal, Actual_Volume_Method_Anchor,
  Auto_Anchor_Policy_Auto, Auto_Anchor_Policy_Manual, Auto_Anchor_Policy_None,
  Calc_VolumeLayer_Type_EDLP, EventSpend_Type_EDLP, Event_Type_MerchSimple, Calc_VolumeLayer_Type_Merch, Event_Types_Other,Event_Type_Display,
  PaymentMethod_OffInvoice, PaymentMethod_Check, PaymentMethod_Deduction,PaymentMethod_Rebate,
  Product_RowType_Consumer,Product_RowType_Finished, Product_RowType_Display,
  Spend_Ship_Volume_Basis_All,Spend_Ship_Volume_Basis_OSOnly, Spend_Ship_Volume_Basis_BOMCompOnly, Spend_Ship_Volume_Basis_BOMHeader
}
